// extracted by mini-css-extract-plugin
export default {"container":"tcgjA","slide":"_4atT5","postWrapper":"gYpSO","separator":"yZg-P"};